var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D3DCEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.2306H14.638C14.6392 15.1484 14.6402 15.0583 14.6411 14.9612C14.6453 14.4793 14.6457 13.8138 14.6438 13.0764C14.6405 11.799 14.6301 10.301 14.6202 9.15625H16.8452L19.5 12.5954V15.2306Z",
    stroke: "#7C8092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0413 12.5547H19.0001",
    stroke: "#7C8092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1239 15.7934C13.1768 15.6347 13.146 9.865 13.1239 7H4V15.7934",
    stroke: "#7C8092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.7227H13.625",
    stroke: "#7C8092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39254 15.8608C8.39254 16.388 7.96518 16.8153 7.438 16.8153C6.91082 16.8153 6.48346 16.388 6.48346 15.8608C6.48346 15.3336 6.91082 14.9062 7.438 14.9062C7.96518 14.9062 8.39254 15.3336 8.39254 15.8608Z",
    fill: "white",
    stroke: "#7C8092"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5742 15.8608C18.5742 16.388 18.1469 16.8153 17.6197 16.8153C17.0925 16.8153 16.6652 16.388 16.6652 15.8608C16.6652 15.3336 17.0925 14.9062 17.6197 14.9062C18.1469 14.9062 18.5742 15.3336 18.5742 15.8608Z",
    fill: "white",
    stroke: "#7C8092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83594 8.71484L10.9063 10.7852L8.83594 12.8555",
    stroke: "#7C8092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9063 10.7852H6.24805",
    stroke: "#7C8092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check_in.6c4daf3a728731f10357587a5eaa827e.svg";
export { ForwardRef as ReactComponent };